import { CSSProperties, memo, useMemo } from "react"
import { OrderStatus, SecondaryOrderStatus } from "../../proto/generated/order";
import { getOrderStatusColor, getOrderStatusText } from "../../util/orders";

export type OrderStatusProps = {
    status: OrderStatus,
    secondaryStatus?: SecondaryOrderStatus,
    style?: CSSProperties
}

const OrderStatusDisplay: React.FC<OrderStatusProps> = ( {status, secondaryStatus, style = {}} ) => {

    const mergedStyles: CSSProperties = useMemo(() => ({ ...style, color: getOrderStatusColor(status)}), [status, style])
    return <span style={mergedStyles} >{getOrderStatusText(status, secondaryStatus)}</span>;
}

export default memo(OrderStatusDisplay)
